import React from 'react';
import PropTypes from 'prop-types';
import RadiosWrapper from './RadiosWrapper';
import {gofor} from '@fiverr-private/futile';

class ModalBody extends React.Component {

    constructor(props) {
        super(props);

        this.blockReasons = ['abusive', 'provide', 'negative'];

        const reason = this.blockReasons[0];
        const reasonText = i18n.t(`seller_card.block_user.options.${this.defaultBlockReason}`);

        this.reasonLength = 100;
        this.specialChars = /[@^&*_+=\\[\]{};\\|<>\\/]/; // eslint-disable-line

        this.state = {
            selectedReason: {
                reason,
                reasonText
            },
            confirmEnabled: this.isValid(reason, reasonText)
        };

        const boundFunctions = [
            'confirmModal',
            'changeReason',
            'isValid'
        ];
        boundFunctions.forEach((fn) => this[fn] = this[fn].bind(this));
    }

    changeReason(reason, reasonText) {

        this.setState({
            selectedReason: {
                reason,
                reasonText
            },
            confirmEnabled: this.isValid(reason, reasonText)
        });
    }

    isValid(reason, reasonText) {
        const isValidLength = reasonText.length > 0 && reasonText.length < this.reasonLength,
            hasSpecialChart = this.specialChars.test(reasonText);

        const isValidText = isValidLength && !hasSpecialChart;
        return !(reason === 'other' && !isValidText);
    }

    confirmModal() {

        const {
            reason,
            reasonText
        } = this.state.selectedReason;

        if (this.isValid(reason, reasonText)) {
            const url = `/users/${this.props.userId}/interaction_blocking/block`;

            const data = {
                reason: reasonText
            };

            this.setState({
                confirmEnabled: false
            });

            gofor(url, {
                method: 'POST',
                body: JSON.stringify(data)
            }).then((response) => response.json()).then((responseData) => {
                if (responseData.success) {
                    this.props.closeModal();
                    this.props.submitBlockTrigger();
                    this.setState({
                        confirmEnabled: true
                    });
                }
            }).catch(() => {
                this.setState({
                    confirmEnabled: true
                });
                this.props.closeModal();
            });
        }
    }

    render() {

        const {
            closeModal,
            userName
        } = this.props;

        return (
            <div className="block-user-body modal-body">
                <p>
                    {i18n.t('seller_card.block_user.description')}<a href={i18n.t('seller_card.block_user.learn_more_text')}> {i18n.t('seller_card.block_user.learn_more')}</a>
                </p>
                <h4>{i18n.t('seller_card.block_user.question', {userName})}</h4>
                <RadiosWrapper changeReason={this.changeReason}
                    blockReasons={this.blockReasons}
                    selectedReason={this.state.selectedReason}/>
                <div className="button-wrapper">
                    <button className="btn-lrg-standard btn-white" onClick={closeModal}>
                        {i18n.t('seller_card.block_user.cancel')}
                    </button>
                    <button disabled={!this.state.confirmEnabled} className="btn-lrg-standard" onClick={this.confirmModal}>
                        {i18n.t('seller_card.block_user.submit')}
                    </button>
                </div>
            </div>
        );
    }
}

ModalBody.propTypes = {
    userName: PropTypes.string,
    userId: PropTypes.number,
    submitBlockTrigger: PropTypes.func
};

ModalBody.defaultProps = {
    userName: '',
    userId: 0
};

export default ModalBody;


// WEBPACK FOOTER //
// ./src/components/block_user/ModalWrapper/ModalBody/index.js